// Shopify owns submission and CAPTCHA. Never infer delivery from client state.
(() => {
  const form = document.getElementById('HaroWholesaleForm');
  if (!form) return;
  const result = form.querySelector('[data-wholesale-result]');
  const key = 'haro-wholesale-submission-v2';
  try { sessionStorage.removeItem('haro-wholesale-submission-v1'); } catch (_) {}
  // Preserve only program selections across a Shopify validation response.
  // Contact details, street addresses and free-text responses stay out of Web Storage.
  const fields = ['business_country', 'business_type', 'partnership_interest', 'estimated_monthly_volume'];
  const input = name => form.elements.namedItem(`contact[${name}]`);
  const clear = () => { try { sessionStorage.removeItem(key); } catch (_) {} };
  if (result?.dataset.wholesaleResult === 'success') clear();
  else {
    form.querySelectorAll('select[data-returned-value]').forEach(select => {
      if (select.dataset.returnedValue) select.value = select.dataset.returnedValue;
    });
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved && Date.now() - saved.at < 30 * 60 * 1000 && saved.path === location.pathname && result?.dataset.wholesaleResult === 'error') {
        fields.forEach(name => {
          const field = input(name);
          if (field && !field.value && typeof saved.values[name] === 'string') field.value = saved.values[name].slice(0, field.maxLength > 0 ? field.maxLength : 2000);
        });
      } else clear();
    } catch (_) { clear(); }
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      const values = {};
      fields.forEach(name => { if (input(name)) values[name] = input(name).value; });
      try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), path: location.pathname, values })); } catch (_) {}
    });
  }
  const dialog = document.getElementById('wholesale-application');
  if (!dialog || typeof dialog.showModal !== 'function') {
    if (result) result.focus();
    return;
  }
  const hashes = ['#wholesale-application', '#HaroWholesaleForm', '#WholesaleResult'];
  const success = result?.dataset.wholesaleResult === 'success';
  const returning = history.state?.haroWholesaleConfirmed || performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
  const requested = hashes.includes(location.hash);
  let opener;
  const cleanReturnUrl = () => {
    const url = new URL(location.href);
    if (hashes.includes(url.hash)) url.hash = '';
    if (url.searchParams.get('apply') === 'new') url.searchParams.delete('apply');
    if (success) url.searchParams.delete('contact_posted');
    history.replaceState({ ...history.state, ...(success ? { haroWholesaleConfirmed: true } : {}) }, '', url);
  };
  dialog.close();
  dialog.dataset.modalReady = 'true';
  dialog.querySelector('[data-wholesale-close]').hidden = false;
  const open = trigger => {
    if (success && trigger) {
      // A new application needs a fresh server-rendered form, not the old receipt.
      const url = new URL(location.href);
      url.searchParams.delete('contact_posted');
      url.searchParams.set('apply', 'new');
      url.hash = 'wholesale-application';
      location.assign(url.href);
      return;
    }
    opener = trigger;
    const interest = input('partnership_interest');
    if (interest && trigger?.dataset.wholesaleInterest) interest.value = trigger.dataset.wholesaleInterest;
    cleanReturnUrl();
    if (!dialog.open) dialog.showModal();
    dialog.dispatchEvent(new Event('haro:wholesale-open'));
    dialog.scrollTop = 0;
    (result || dialog.querySelector('#WholesaleApplyTitle')).focus({ preventScroll: true });
  };
  document.querySelectorAll('a[href="#wholesale-application"]').forEach(trigger => {
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', dialog.id);
    trigger.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      open(trigger);
    });
  });
  dialog.querySelector('[data-wholesale-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  window.addEventListener('hashchange', () => { if (hashes.includes(location.hash)) open(); });
  window.addEventListener('pagehide', () => { if (dialog.open) dialog.close(); });
  window.addEventListener('pageshow', event => { if (event.persisted && dialog.open) dialog.close(); });
  if (success) cleanReturnUrl();
  if (!returning && (result || requested)) {
    if (requested && !result) window.scrollTo({ top: 0, behavior: 'instant' });
    open();
  }
})();
